import React  from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
// const LazyDotLottie = React.lazy(() => import('dotlottie-react'));


const GlobalLoader = ()=>{
    return(
        <div id="loaderBG">
            <div className='gifBg'>
            {/* <Suspense fallback={<div>Loading animation...</div>}> */}
                <DotLottieReact
                    src="/assets/img/loader.json"
                    style={{ width: '300px', height: '300px' }}
                    loop
                    speed={2}
                    autoplay
                />
                {/* </Suspense> */}
        </div>
        
        </div>
    )
}

export default GlobalLoader;
